'use strict';

export default class SearchGlobal {
    constructor() {

        let $template_html;
        let $index_name = 'search_contents';
        let $app_id = 'PV21YPDECK';
        let $app_key = '999fc9d3376250fbb4c0d870bb15e65c';
        let $search_box_element = "#search-box";
        let $search_container = ".search-bar";
        let $page_size = 5;
        let $speechSupported = false;
        let timerId;

        // Change the index based on the user logged in
        $('.current-user-role.personal_member').length ? $index_name = 'search_contents_personal_member' : '';
        $('.current-user-role.volunteer').length ? $index_name = 'search_contents_volunteer' : '';
        $('.current-user-role.staff').length ? $index_name = 'search_contents_volunteer' : '';
        $('.current-user-role.administrator').length ? $index_name = 'search_contents_volunteer' : '';

        console.log('Current admin div:', $('.current-user-role.administrator').length);
        console.log('Current search index:', $index_name);

        let $containers = {
            pagingation: '#pagination',
            search_box: '#search-box',
            search_box_placeholder: 'Search',
            search_result: '#results',
            facets_top: '#facets_top',
            facets_clear_top: '#facets-clear_top',
            facets_middle: '#facets_middle',
            facets_clear_middle: '#facets-clear_middle',
            voice_search: '#voice-search',
            search_container: '.search-box-elements',
            sorting: '#search_sorting',
            stats: '#search_stats',
        }

        let $configurations = {
            sorting: [
                { label: 'Relevance', value: $index_name },
                { label: 'Oldest', value: $index_name + '_date_asc' },
                { label: 'Newest', value: $index_name + '_date_desc' },
            ]
        }

        if ($('.path-resources').length) {
            $index_name = 'search_resources';
            $containers.search_box = '#search-box-resources';
            $containers.search_box_placeholder = 'Search Resources';
            $configurations.sorting = [
                { label: 'Relevance', value: 'search_resources' },
                { label: 'Oldest', value: $index_name + '_date_asc' },
                { label: 'Newest', value: $index_name + '_date_desc' },
            ];

        }


        // If we have a container then load
        if (haveSearchContainer()) {
            checkIfSpeechSupported();
            buildTemplates();
            loadAlgoliaSearch();
            gridListButtonAction();
        }

        function loadAlgoliaSearch() {

            console.log('loadAlgoliaSearch');
            console.log('Current admin div:', $('.current-user-role.administrator').length);

            let searchClient = algoliasearch($app_id, $app_key);

            let $search = instantsearch({
                indexName: $index_name,
                searchClient,
                routing: {
                    stateMapping: instantsearch.stateMappings.simple(),
                }
            });
            
            //alert('load algo');

            $search.addWidgets([

                instantsearch.widgets.configure({
                    hitsPerPage: $page_size,
                    attributesToSnippet: ['body:30'],
                }),

                // Pagination
                instantsearch.widgets.pagination({
                    container: $containers.pagingation,
                }),

                // Search box
                instantsearch.widgets.searchBox({
                    
                    container: $containers.search_box,
                    placeholder: $containers.search_box_placeholder,
                    // showReset: true,
                    autofocus: true,
                    showLoadingIndicator: true,
                    queryHook(query, search) {
                        // $('.ais-SearchBox-loadingIndicator').removeAttr('hidden');
                        // setTimeout(function () {
                        //     $('.ais-SearchBox-loadingIndicator').attr('hidden', true);
                        //     search(query)
                        // }, 800);
                        clearTimeout(timerId);
                        timerId = setTimeout(() => search(query), 600);
                    },
                }),

                // Voice search
                instantsearch.widgets.voiceSearch({
                    container: $containers.voice_search,
                    // searchAsYouSpeak: true,
                    templates: {
                        status: `
                          <div class="listening {{isListening}}"><img src="/themes/aba/images/ripple.pink.svg"></div>
                        `,
                    },
                }),


                // Facets
                // instantsearch.widgets.refinementList({
                //     container: $containers.facets_middle,
                //     attribute: 'content_type',
                //     sortBy: ['name:asc'],
                //     // limit: 5,
                //     // showMore: false,
                // }),

                // Sorting
                instantsearch.widgets.sortBy({
                    container: $containers.sorting,
                    items: $configurations.sorting,
                }),

                // Result stats
                instantsearch.widgets.stats({
                    container: $containers.stats,
                    templates: {
                        text: $template_html.stats
                    }
                }),

                // Clear facets
                instantsearch.widgets.clearRefinements({
                    container: $containers.facets_clear_middle,
                }),

                // Search results
                instantsearch.widgets.hits({
                    container: $containers.search_result,
                    templates: {
                        empty: $template_html.no_result,
                        item: $template_html.search_item,
                    },
                    transformItems($items) {
                        var $item_transformed_image_path = changeImageToThumbnail($items);

                        if ($items.length < 1)
                            $("#pagination").addClass("visually-hidden");
                        else
                            $("#pagination").removeClass("visually-hidden");

                        return $item_transformed_image_path;
                    }
                }),
            ]);

            if ($('.path-resources').length) {
                $search.addWidgets([
                    // Facets
                    instantsearch.widgets.refinementList({
                        container: $containers.facets_middle,
                        attribute: 'topic',
                        sortBy: ['count:desc'],
                        limit: 10,
                        showMore: true,
                        showMoreLimit: 200,
                        // showMore
                    }),
                    // Facets
                    instantsearch.widgets.refinementList({
                        container: $containers.facets_top,
                        attribute: 'audience',
                        sortBy: ['count:desc'],
                        showMore: true,
                        showMoreLimit: 200,
                        // limit: 5,
                        // showMore: true,
                    }),
                ]);
            } else {

                $search.addWidgets([
                    // Facets
                    instantsearch.widgets.refinementList({
                        container: $containers.facets_middle,
                        attribute: 'resource_type',
                        sortBy: ['count:desc'],
                        limit: 10,
                        showMore: true,
                        showMoreLimit: 200,
                        // showMore
                    }),
                    // Facets
                    instantsearch.widgets.refinementList({
                        container: $containers.facets_top,
                        attribute: 'audience',
                        sortBy: ['count:desc'],
                        showMore: true,
                        showMoreLimit: 200,
                        // limit: 5,
                        // showMore: true,
                    }),
                ]);

            }



            $search.start();

            $search.on('render', function () {
                console.log('Algolia search complete');
                // clearFacetButton();
                gridListButton();
                reapplyMasonry();
            });
        }
        function gridListButton() {
            $('.grid-list-switch').addClass('active');
        }
        function gridListButtonAction() {
            $('.grid-list-switch').click(function () {

                if ($('.search-full-page').hasClass('card')) {
                    $('.grid-list-switch').removeClass('card');
                    $('.search-full-page').removeClass('card');
                    $('.ais-Hits-list').masonry('destroy');
                } else {
                    $('.grid-list-switch').addClass('card');
                    $('.search-full-page').addClass('card');
                    $('.ais-Hits-list').masonry({
                        itemSelector: '.ais-Hits-item',
                        columnWidth: '.ais-Hits-item',
                        gutter: 30
                    })

                }
            });


        }
        function reapplyMasonry() {
            if ($('.search-full-page').hasClass('card')) {
                $('.ais-Hits-list').masonry('destroy');
                $('.ais-Hits-list').masonry({
                    itemSelector: '.ais-Hits-item',
                    columnWidth: 410,
                    gutter: 30
                })
            }
        }
        function clearFacetButton() {
            // append clear button
            $('.clear-facet').remove();
            $('.clear-facet-container').remove();

            if ($('.ais-RefinementList-checkbox:checked').length) {
                $('.ais-RefinementList-list').prepend("<li class='clear-facet-container'><button class='clear-facet'>Clear</button></li>")

                $('.clear-facet').click(function () {
                    $('.ais-ClearRefinements-button').click();
                })
            }


        }
        function changeImageToThumbnail($items) {

            $.each($items, function ($index, $item) {
                if ($item['thumbnail']) {
                    var $full_image_path = $item['thumbnail'];
                    var $new_image_path = $full_image_path.replace("/sites/default/files/", "/sites/default/files/styles/thumbnail/public/");
                    $items[$index]['thumbnail'] = $new_image_path;
                }

            })

            return $items;
        }
        function haveSearchContainer() {
            if (!$($containers.search_box).length) {
                return false;
            } else {
                return true;
            }
        }
        function buildTemplates() {

            console.log('buildTemplates');

            var $item = "";
            $item += '<div class="item">';
            $item += '{{#icon}}<div class="icon"><img width="40" height="40" src="{{icon}}"></div>{{/icon}}';
            $item += '<div class="tag">{{#tags}}<span>{{tags}}</span>{{/tags}}<span>{{content_type}}</span></div>';
            $item += '{{#thumbnail}}<div class="thumbnail"><img width="280" height="168" src="{{thumbnail}}"></div>{{/thumbnail}}';
            $item += '<div class="title"><a href="{{ url }}"><h3>{{#helpers.highlight}}{"attribute": "title"}{{/helpers.highlight}}</h3></a></div>';
            // $item += '{{#description}}<div class="description">{{#helpers.highlight}}{"attribute": "description"}{{/helpers.highlight}}</div>{{/description}}';
            $item += '{{#body}}<div class="body">{{#helpers.snippet}}{"attribute": "body"}{{/helpers.snippet}}</div>{{/body}}';
            $item += '<a href="{{ url }}">Read more</a>';
            $item += '</div><br><br>';


            var $search_result_stats = "";
            $search_result_stats += '<div class="searching-stats">';
            $search_result_stats += '<div class="label">Search results {{#query}}for \'{{query}}\'{{/query}}</div>';
            $search_result_stats += '<div class="result_count">{{nbHits}}</div>';
            $search_result_stats += '</div>';


            $template_html = {
                search_item: $item,
                no_result: '<div class="no-result">No match found</div>',
                index_item: '',
                stats: $search_result_stats,
            }
        }
        function checkIfSpeechSupported() {
            if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
                console.log('speech recognition API supported')
                $($containers.search_container).addClass('speech-supported');
                $speechSupported = true;
            } else {
                console.log('speech recognition API not supported');
            }

        }

    }
}